import styled from 'styled-components/macro';
import { colorCoreGray500 } from '@yme/tokens/colors';
export const ContainerStyled = styled.div `
  display: flex;
  justify-content: space-between;
  padding: 0 16px 12px 16px;
  border-bottom: 1px solid ${colorCoreGray500};

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
